import React from "react";
import Feature from "./Feature/Feature";
import Search from "../../resources/feature-search.png";
import Database from "../../resources/Database.png";
import Metric from "../../resources/Metric.png";
import BrokenLink from "../../resources/Broken-link.png";
import Clock from "../../resources/Clock.png";
import SeoReport from "../../resources/Seo-report.png";
import "./HomeSectionFour.css";

function HomeSectionFour() {
  return (
    <div className="homeSectionFour">
      <div className="homeSectionFour__one">
        <div className="homeSectionFour__one--heading">
          <h2>Why Guest Post Mesh</h2>
        </div>
        <div className="homeSectionFour__one--subHeading">
          <p>
            GuestPostNetwork is a marketplace where you can easily buy guest
            posts from high-quality websites and sell guest post opportunities
            on yours
          </p>
        </div>
      </div>

      <div className="homeSectionFour__two">
        <div className="homeSectionFour__two--features">
          <Feature
            image={Search}
            heading={"Search Engine"}
            subHeading={
              "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled"
            }
          />

          <Feature
            image={Database}
            heading={"Largest Database"}
            subHeading={
              "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled"
            }
          />

          <Feature
            image={Metric}
            heading={"Updated Key Metrics"}
            subHeading={
              "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled"
            }
          />
        </div>

        <div className="homeSectionFour__two--features">
          <Feature
            image={SeoReport}
            heading={"Quality Prospecting"}
            subHeading={
              "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled"
            }
          />

          <Feature
            image={Clock}
            heading={"Save Time & Money"}
            subHeading={
              "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled"
            }
          />

          <Feature
            image={BrokenLink}
            heading={"Powerful Backlinks"}
            subHeading={
              "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled"
            }
          />
        </div>
      </div>

      <div className="homeSectionFour__three">
        <div className="homeSectionFour__three--buttons">
          <button className="homeSectionFour__three--signup">Signup Now</button>
          <button className="homeSectionFour__three--demo">Book a Demo</button>
        </div>
      </div>
    </div>
  );
}

export default HomeSectionFour;
